export namespace TaskSettingsTranslations {
  export const components = {
    taskSettingsProcessStockLocationRoleLabel: 'taskSettingsProcessStockLocationRoleLabel',
  } as const;
}
